// extracted by mini-css-extract-plugin
export default {"root":"list_root__WYZzr","item":"list_item__XjPH3","itemLabel":"list_itemLabel__I1fMN","itemWrapper":"list_itemWrapper__WsPnJ"};